import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';

export const approveGradesOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  sessionId: number | undefined,
  gradesApproved: boolean,
  setGradesApproval: (approve: boolean) => any,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId || !sessionId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    const res = await appApi.updateGradesApproval(
      programId,
      courseId,
      examId,
      sessionId,
      gradesApproved,
    );

    setSessionDetails(res.data.body);
    setGradesApproval(gradesApproved);
  } catch (e) {
    toast.error(`משהו קרה, נשב שוב בעוד מספר רגעים...`);
    console.error(
      `approveGradesOperations is failed with the programId: ${programId}, courseId: ${courseId}, examId: ${examId}, sessionId: ${sessionId} with the error: ${e}`,
    );
  }
};
